import {
  ICatalogChooser,
  ICatalogOption,
} from "@/components/excel/schema/definiens/catalog";
import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/value/type/area";
import { ITypeChooser } from "@/components/excel/schema/definiens/bizType";
import {
  DayOption,
  MonthOption,
  YearOption,
} from "@/components/excel/schema/value/type/date";
import {
  HourOption,
  MinuteOption,
  SecondOption,
} from "@/components/excel/schema/value/type/time";
import {
  CurrencyOption,
  MoneyOption,
  OtherOption,
  SexOption,
} from "@/components/excel/schema/value/type/other";

export const AreaType: ITypeChooser = {
  default: ProvinceOption.value,
  options: [ProvinceOption, CityOption, CountyOption],
};
export const AreaOption: ICatalogOption = {
  value: 2,
  text: "地区",
  type: AreaType,
};

export const DateType: ITypeChooser = {
  default: YearOption.value,
  options: [YearOption, MonthOption, DayOption],
};
export const DateOption: ICatalogOption = {
  value: 3,
  text: "日期",
  type: DateType,
};
export const TimeType: ITypeChooser = {
  default: HourOption.value,
  options: [HourOption, MinuteOption, SecondOption],
};
export const TimeOption: ICatalogOption = {
  value: 4,
  text: "时间",
  type: TimeType,
};
// export const OtherType: ITypeChooser = {
//   default: OtherOption.value,
//   options: [SexOption, CurrencyOption, MoneyOption, OtherOption]
// };
export const OtherType: ITypeChooser = {
  default: OtherOption.value,
  options: [SexOption, OtherOption],
};
export const OtherCatalogOption: ICatalogOption = {
  value: 1,
  text: "其他",
  type: OtherType,
};

export const CatalogChooser: ICatalogChooser = {
  default: OtherCatalogOption.value,
  options: [AreaOption, DateOption, TimeOption, OtherCatalogOption],
};
